const initialState = {
    reset: [], 
    
  
  };
  
  const ResetReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_RESET_SUCCESS':
            return {... state, reset:action.payload};
            
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default ResetReducers;
  
  